import { Container, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <Container 
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card text-center" style={{ width: 500, maxWidth: "100%" }}>
        <Card.Body className="p-5">
          <h2 className="brutal-heading mb-4" style={{ fontSize: "36px" }}>
            DASHBOARD
          </h2>
          <p className="brutal-text mb-4" style={{ fontSize: "18px" }}>
            YOU ARE SIGNED IN
          </p>
          <div className="d-flex flex-column gap-3">
            <Button 
              onClick={() => navigate("/profile")} 
              className="brutal-btn brutal-btn-primary w-100"
            >
              VIEW PROFILE
            </Button>
            <Button 
              onClick={logout} 
              className="brutal-btn brutal-btn-danger w-100"
            >
              LOGOUT
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}